import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardTitle,
  Input,
  CustomInput,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../components/Validation';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faLink } from '@fortawesome/free-solid-svg-icons';
import IntlMessages from '../../../../../helpers/IntlMessages';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
import {
  putAPI_Delete_Response,
  putAPI_Update_Response,
  gAPI_Response_By_Code,
  gAPI_Response_HotelAssistantOptions
} from '../../../../../constants/APIs';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import ImageGallery from './../../propinfo/gallery';
function WelcomeMessage({
  title,
  locale,
  integrationProperties,
  allProperties,
  propertyId,
  channel,
  botSettings,
  saveIntegration,
  integrationId,
  serviceProvider,
}) {
  const [titleInput, setTitleInput] = useState('');
  const [subTitleInput, setSubTitleInput] = useState('');
  const [linkInput, setLinkInput] = useState('');
  const [allButtons, setAllButtons] = useState([]);
  const [buttonList, setButtonList] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [selectedLang, setSelectedLang] = useState(locale);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: 'welcome_card_special',
    Language: 'en-US',
    Channel: 'WebsiteDirectLine',
    PropertyId:
      integrationProperties !== undefined && integrationProperties.length === 1
        ? integrationProperties[0]
        : undefined,
    Default: null,
    Overrides: {},
    UserName: '',
  });
  const [instructions, setInstructions] = useState(
    botSettings?.aiInstructions || ''
  );

  useEffect(() => {
    if (postData.PropertyId) {
      reloadBotResponse(postData.PropertyId, selectedLang);
    }
  }, [selectedLang]);
  useEffect(() => {
    const selectedButtons = buttonList.map(button => ({
      text: button.text,
      value: button.value,
    }));
    setPostData(prev => ({
      ...prev,
      Default: {
        Title: titleInput,
        SubTitle: subTitleInput,
        ImageUrl: linkInput,
        Buttons: selectedButtons,
      },
    }));
  }, [titleInput, subTitleInput, linkInput, buttonList]);
  const handleInstructionsChange = (e) => {
    setInstructions(e.target.value);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const SwitchLanguage = (lang) => {
    setSelectedLang(lang);

    setPostData(prev => ({
      ...prev,
      Language: lang === "en" ? "en-US" : lang
    }));
  };
  const selectedImage = (link) => {
    setLinkInput(link.src);
  };

  const handleDelete = (code) => {
    let data;
    if (postData.PropertyId !== undefined) {
      data = {
        GroupId: getGroupID(),
        PropertyId: postData.PropertyId,
        Language: postData.Language,
        Channel: 'WebsiteDirectLine',
      };
    } else {
      data = {
        GroupId: getGroupID(),
        Language: postData.Language,
        Channel: 'WebsiteDirectLine',
        UserName: '',
      };
    }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Response}/${'business_domain_welcome_message'}`,
      data: data,
    })
      .then((res) => {
        //console.log(res.data);
        toggle();
      })
      .finally(() => {
        setTimeout(() => {
          reloadBotResponse(postData.PropertyId);
        }, 1000)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTextChange = (e) => {
    setTitleInput(e.target.value);
  };

  const handleSubTitleChange = (e) => {
    setSubTitleInput(e.target.value);
  };

  const handleUrlChange = (e) => {
    setLinkInput(e.target.value);
  };
  const handleButtonCheck = (button, checked) => {
    setAllButtons(prev =>
      prev.map(item =>
        item.value === button.value
          ? {
            ...item,
            checked,
          }
          : item
      )
    );

    if (checked) {
      setButtonList(prev => {
        if (prev.some(item => item.value === button.value)) {
          return prev;
        }

        return [
          ...prev,
          {
            text: button.text,
            value: button.value,
          },
        ];
      });
    } else {
      setButtonList(prev =>
        prev.filter(item => item.value !== button.value)
      );
    }
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-2">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const reloadBotResponse = async (
    property_id,
    language = selectedLang
  ) => {
    let apiLang = language === "en" ? "en-US" : language;

    if (apiLang === "zh-TW") {
      apiLang = "hk";
    }

    const url =
      `${gAPI_Response_By_Code}/?property_id=${property_id}` +
      `&group_id=${getGroupID()}` +
      `&lang=${apiLang}` +
      `&code=welcome_card_special`;

    try {
      const res = await AxiosAPI({
        method: "get",
        url,
      });

      if (res.data.response !== undefined) {
        const selectedButtons =
          res.data.response?.buttons || [];
        const result = await AxiosAPI({
          method: "get",
          url:
            `${gAPI_Response_HotelAssistantOptions}/?property_id=${property_id}` +
            `&group_id=${getGroupID()}` +
            `&lang=${apiLang}`,
        });

        const welcomeCard = result.data?.find(
          item => item?.query?.code === "welcome_card_special"
        );
        const availableButtons =
          welcomeCard?.query?.buttons || [];
        const buttons = availableButtons.map(button => {
          const selectedButton = selectedButtons.find(
            selected => selected.value === button.value
          );

          return {
            ...button,
            checked: !!selectedButton,
          };
        });
        setAllButtons(buttons);

        setButtonList(
          buttons.filter(button => button.checked)
        );

        setPostData(prev => ({
          ...prev,
          PropertyId: property_id,
          Language: language === "en" ? "en-US" : language,
          Default: {
            Title: res.data.response?.title,
            SubTitle: res.data.response?.subtitle,
            ImageUrl: res.data.response?.imageURL,
            Buttons: selectedButtons,
          },
        }));

        setTitleInput(res.data.response?.title || "");
        setSubTitleInput(res.data.response?.subtitle || "");
        setLinkInput(res.data.response?.imageURL || "");

      } else {
        setTitleInput("");
        setSubTitleInput("");
        setLinkInput("");
        setAllButtons([]);
        setButtonList([]);
      }

    } catch (err) {
      console.log(err);
    }
  };

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-2">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This response will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() =>
                      handleDelete('welcome_card_special')
                    }
                    size="xs"
                  >
                    <IntlMessages id="dashboards.delete" />
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    <IntlMessages id="pages.cancel" />
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  useEffect(() => {
    if (integrationProperties?.length > 0) {
      const firstProperty = integrationProperties[0];

      setPostData(prev => ({
        ...prev,
        PropertyId: firstProperty
      }));

      reloadBotResponse(firstProperty);
    }
    if (channel === 'WhatsApp' && integrationProperties !== undefined &&
      integrationProperties.length > 1
    ) {
      reloadBotResponse(integrationProperties[0]);
      setPostData({ ...postData, PropertyId: integrationProperties[0] });
    }
  }, [propertyId]);

  // useEffect(() => {
  //   setInstructions(botSettings?.aiInstructions || '');
  // }, [botSettings]);

  const handleSave = async () => {
    try {
      const res = await AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: postData,
      })

      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsgs(res.data.Messages);
        setOpen(true);
        return;
      }

      saveIntegration({
        botSetting: {
          ...botSettings,
          // aiInstructions: instructions
        }
      });

      NotificationManager.success(
        '',
        'Bot Response updated successfully.',
        3000,
        null,
        null,
        'success'
      );
      setTimeout(() => {
        reloadBotResponse(postData.PropertyId, selectedLang);
      }, 1000);

    } catch (error) {
      console.error(error);
    }
  };

  const handleProperty = (id) => {
    setPostData(prev => ({
      ...prev,
      PropertyId: id
    }));

    reloadBotResponse(id, selectedLang);
  };
  const allowedAvenButtons = [
    'seerooms',
    'leavedetails',
    'humanchat',
    'real_person',
    'roomdetails',
  ];
  const titlename = (title || '').toLowerCase().trim();

  const filteredButtons =
    titlename === 'hotel' &&
      (serviceProvider === "5" || serviceProvider === "2")
      ? allButtons.filter(btn =>
        allowedAvenButtons.includes(btn.value)
      )
      : allButtons;

  const Editing = () => {
    return (
      <Fragment>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
        <div className="text-center mb-2">
          <h6>Welcome Message</h6>
        </div>
        <Separator className="my-2"></Separator>
        <Card className="m-4 p-4">
          <Colxx xxs="12" className="px-0">
            {/* <div className="mb-2">
              <h6 style={{ marginBottom: '4px' }}>
                Property Selection Message
              </h6>
              <p className="text-muted" style={{ fontSize: '12px' }}>
                Prompt users to choose a property before continuing
              </p>
            </div> */}
            {integrationProperties !== undefined &&
              integrationProperties?.length > 0 &&
              channel !== "WhatsApp" && (
                <Fragment>
                  <CardTitle>
                    <Row>
                      <Colxx xxs="6">
                        <h6>Select Business/Property</h6>
                      </Colxx>
                    </Row>
                  </CardTitle>
                  <Row>
                    <Colxx xxs="12" className="mb-2">
                      <Input
                        type="select"
                        value={postData.PropertyId}
                        onChange={(e) => handleProperty(e.target.value)}
                      >
                        <option value="">Please Select</option>
                        {allProperties !== undefined &&
                          allProperties.length > 0 &&
                          allProperties
                            .filter(f => integrationProperties.includes(f.id))

                            .map((p) => {
                              if (
                                p.domains !== undefined
                                // p?.domains[0]?.type !== undefined &&
                                // p?.domains?.filter(
                                //   (f) =>
                                //     f.type === 'BusinessOperator' ||
                                //     f.type === 'UtilityProviders'
                                // ).length > 0
                              )
                                return <option key={p.id} value={p.id}>{p.name}</option>;
                            })}
                      </Input>
                    </Colxx>
                  </Row>
                </Fragment>
              )}
            <LanguageTabs
              selectedTab={selectedLang}
              setLanguage={SwitchLanguage}
            />
            {channel !== 'WhatsApp' && (
              <CardTitle>
                <Row>
                  <Colxx xxs="6">
                    <h6>
                      {/* <FontAwesomeIcon icon={faCommentDots} />
                      <span> </span> */}
                      <IntlMessages id="property.Title" />
                    </h6>
                  </Colxx>
                </Row>
              </CardTitle>
            )}
            {channel !== 'WhatsApp' && (
              <Row>
                <Colxx xxs="12" className="mb-2">
                  <Input
                    type="textarea"
                    value={titleInput}
                    onChange={handleTextChange}
                  />
                </Colxx>
              </Row>
            )}
            {channel !== 'WhatsApp' && (
              <CardTitle>
                <Row>
                  <Colxx xxs="6">
                    <h6>
                      {/* <FontAwesomeIcon icon={faCommentDots} />
                      <span> </span> */}
                      <IntlMessages id="property.SubTitle" />
                    </h6>
                  </Colxx>
                </Row>
              </CardTitle>
            )}
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="textarea"
                  value={subTitleInput}
                  onChange={handleSubTitleChange}
                />
                {/* <Input
                  type="textarea"
                  value={subTitleInput}
                  onChange={handleSubTitleChange}
                  placeholder="Enter welcome message here..."
                  style={{ height: '100px' }}
                /> */}
              </Colxx>
            </Row>
            {channel !== 'WhatsApp' && (
              <CardTitle>
                <Row>
                  <Colxx xxs="6">
                    <h6>
                      {/* <FontAwesomeIcon icon={faLink} />
                      <span> </span> */}
                      <IntlMessages id="dashboards.imagelink" />
                    </h6>
                  </Colxx>
                </Row>
              </CardTitle>
            )}
            {channel !== 'WhatsApp' && (
              <Row>
                <Colxx xxs="10">
                  <Input
                    type="text"
                    value={linkInput}
                    onChange={handleUrlChange}
                  ></Input>
                </Colxx>
                <Colxx xxs="2" className="px-2">
                  {' '}
                  <Button
                    color="primary"
                    outline
                    className="add-button mt-1"
                    size="xs"
                    onClick={togglegallery}
                  >
                    Browse
                  </Button>
                </Colxx>
              </Row>
            )}
            {channel !== 'WhatsApp' && (
              <CardTitle>
                <Row>
                  <Colxx xxs="6">
                    <h6 className='mt-2'>
                      {/* <FontAwesomeIcon icon={faLink} />
                      <span> </span> */}
                      <IntlMessages id="menu.buttons" />
                    </h6>
                  </Colxx>
                </Row>
              </CardTitle>
            )}
            {channel !== 'WhatsApp' && (
              <Row className="mt-2">
                <Colxx xxs="12">
                  <div className="">

                    {filteredButtons?.map((button, index) => (
                      <CustomInput
                        key={button.value || index}
                        type="checkbox"
                        id={`welcome-button-${button.value || index}`}
                        label={button.text}
                        checked={button.checked === true}
                        onChange={(e) =>
                          handleButtonCheck(
                            button,
                            e.target.checked
                          )
                        }
                        className="mb-2"
                      />
                    ))}

                  </div>

                </Colxx>
              </Row>
            )}
            {/* <Row>
                <Colxx xxs="2">
                </Colxx>
                <Colxx xxs="10">
                  <div
                    className="float-left"
                    style={{ marginTop: ' 5px', marginBottom: '5px' }}
                  >
                  </div>
                </Colxx>
              </Row> */}
            {ImageGalleryButton()}
          </Colxx>
        </Card>
        {/* <Card className="m-4 p-4">
          <Colxx xxs="12" className="px-0">
            <div className="mb-3">
              <h6>AI Instructions</h6>
              <div className="text-muted" style={{ fontSize: '12px', marginBottom: '10px' }}>
                Enter instructions to help the AI identify the correct property from the user’s response
              </div>
              <Row>
                <Colxx xxs="12">
                  <Input
                    type="textarea"
                    name="aiInstructions"
                    id="aiInstructions"
                    value={instructions}
                    onChange={handleInstructionsChange}
                    placeholder="Enter AI instructions here..."
                    style={{ height: '100px' }}
                  />
                </Colxx>
              </Row>
            </div>
          </Colxx>
        </Card> */}
        <Separator className="my-4" />
        <div className="text-center">
          <ButtonGroup>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
          </ButtonGroup>
        </div>
        {generateButtonGroup()}
      </Fragment>
    );
  };
  return (
    <Card>
      <CardBody>{Editing()}</CardBody>
      <Validation
        open={open}
        messages={msgs}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Card>
  );
}

const mapStateToProps = ({ settings }) => {
  const { locale, propertyId, serviceProvider } = settings;
  return {
    propertyId,
    locale,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps)(WelcomeMessage));
